module.exports = __webpack_public_path__ + "img/it-softwaredevelopment-01.89dc5392.jpeg";